import { useMutation } from "@tanstack/react-query";
import { updateTeamMemberCredits } from "../api"; // Adjust the import path as needed
import type {
  TeamMemberCreditsResponse,
  TeamMemberCreditsUpdatePayload,
} from "../types";

/**
 * Custom hook to update team member credits using React Query.
 *
 * @returns {Object} - The mutation object containing methods and states for updating team member credits.
 */
export const useUpdateTeamMemberCredits = (): ReturnType<
  typeof useMutation<
    TeamMemberCreditsResponse,
    Error,
    TeamMemberCreditsUpdatePayload
  >
> => {
  return useMutation<
    TeamMemberCreditsResponse, // Type of the response data
    Error, // Type of the error
    TeamMemberCreditsUpdatePayload // Type of the input payload
  >({
    mutationFn: updateTeamMemberCredits, // The function to call for the mutation
    onSuccess: (data) => {
      // Handle success (e.g., show a toast notification or update cache)
      console.log("Team member credits updated successfully:", data.message);
    },
    onError: (error) => {
      // Handle error (e.g., show an error toast)
      console.error("Failed to update team member credits:", error.message);
    },
  });
};
